
export const styles = {
  container: {
    backgroundColor: 'bg-gradient-to-br from-amber-50 via-orange-50 to-yellow-50',
    minHeight: '350px',
    position: 'relative',
    overflow: 'hidden',
    animation: 'emoji-gradient-shift 8s ease-in-out infinite'
  },
  header: {
    background: 'bg-gradient-to-r from-amber-400 via-yellow-400 to-orange-400',
    text: 'text-white font-bold tracking-wide',
    animation: 'emoji-header-shine 3s ease-in-out infinite',
    boxShadow: 'shadow-lg shadow-amber-200/50',
    border: 'border-b-4 border-amber-500/30',
    backdropFilter: 'backdrop-blur-sm'
  },
  avatar: {
    background: 'bg-white',
    text: 'text-amber-500',
    border: 'border-4 border-amber-300',
    animation: 'emoji-bounce-rotate 3s cubic-bezier(0.68, -0.55, 0.265, 1.55) infinite',
    boxShadow: 'shadow-xl shadow-amber-200/50',
    transform: 'rotate(-5deg)',
    shape: 'rounded-full aspect-square overflow-hidden'
  },
  messages: {
    bot: {
      background: 'bg-white backdrop-blur-sm',
      text: 'text-gray-800',
      border: 'border-2 border-amber-200',
      animation: 'emoji-message-pop 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55) forwards',
      boxShadow: 'shadow-lg shadow-amber-100/30'
    },
    user: {
      background: 'bg-gradient-to-br from-amber-400 to-orange-400',
      text: 'text-white',
      border: 'border-2 border-amber-300',
      animation: 'emoji-message-slide 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55) forwards',
      boxShadow: 'shadow-lg shadow-amber-200/30'
    }
  },
  typingIndicator: {
    container: 'bg-white/80 backdrop-blur',
    dots: 'bg-amber-400',
    animation: 'emoji-typing-bounce 1s cubic-bezier(0.68, -0.55, 0.265, 1.55) infinite'
  },
  animations: {
    '@keyframes emoji-gradient-shift': {
      '0%, 100%': {
        backgroundPosition: '0% 50%',
        backgroundSize: '200% 200%'
      },
      '50%': {
        backgroundPosition: '100% 50%',
        backgroundSize: '200% 200%'
      }
    },
    '@keyframes emoji-header-shine': {
      '0%': {
        backgroundPosition: '200% center',
        filter: 'brightness(100%)'
      },
      '50%': {
        backgroundPosition: '0% center',
        filter: 'brightness(110%)'
      },
      '100%': {
        backgroundPosition: '-200% center',
        filter: 'brightness(100%)'
      }
    },
    '@keyframes emoji-bounce-rotate': {
      '0%, 100%': {
        transform: 'rotate(-5deg) scale(1)',
      },
      '50%': {
        transform: 'rotate(5deg) scale(1.1)',
      }
    },
    '@keyframes emoji-message-pop': {
      '0%': {
        transform: 'scale(0.8) translateY(10px)',
        opacity: 0
      },
      '50%': {
        transform: 'scale(1.05) translateY(-5px)',
      },
      '100%': {
        transform: 'scale(1) translateY(0)',
        opacity: 1
      }
    },
    '@keyframes emoji-message-slide': {
      '0%': {
        transform: 'translateX(20px)',
        opacity: 0
      },
      '60%': {
        transform: 'translateX(-5px)',
      },
      '100%': {
        transform: 'translateX(0)',
        opacity: 1
      }
    },
    '@keyframes emoji-typing-bounce': {
      '0%, 100%': {
        transform: 'translateY(0)',
      },
      '50%': {
        transform: 'translateY(-8px)',
      }
    },
    '@keyframes emoji-float-rotate': {
      '0%, 100%': {
        transform: 'translateY(0) rotate(0deg)',
        filter: 'brightness(100%)'
      },
      '25%': {
        transform: 'translateY(-15px) rotate(-5deg)',
        filter: 'brightness(120%)'
      },
      '75%': {
        transform: 'translateY(5px) rotate(5deg)',
        filter: 'brightness(110%)'
      }
    }
  },
  input: {
    container: 'bg-white/80 backdrop-blur border-t-2 border-amber-200',
    field: {
      background: 'bg-white/90',
      text: 'text-gray-800',
      placeholder: 'text-amber-300',
      border: 'border-2 border-amber-200 focus:border-amber-400',
      focus: 'ring-2 ring-amber-400/30',
      animation: 'emoji-input-shine 2s ease-in-out infinite'
    },
    button: {
      background: 'bg-gradient-to-r from-amber-400 to-orange-400 hover:from-amber-500 hover:to-orange-500',
      text: 'text-white',
      animation: 'emoji-button-pop 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55)',
      hover: 'hover:scale-110 hover:shadow-lg hover:shadow-amber-200/50 transition-all duration-300'
    }
  },
  decorations: {
    floatingEmoji: {
      position: 'absolute',
      fontSize: '24px',
      opacity: 0,
      animation: 'emoji-float-rotate 15s ease-in-out infinite',
      zIndex: 1,
      filter: 'drop-shadow(0 0 2px rgba(0, 0, 0, 0.1))'
    }
  }
}; 